// @flow
import React from 'react';
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { isAnythingEditedBesidesGivenFormBasedOnGivenConfig } from '@streaming-projects/utils';
import { useFormikContext } from 'formik';

import { useSPClusterWorkloadContext } from '../contexts/SPClusterWorkloadContextProvider';
import { CLUSTER_WORKLOAD_DETAILS_CONFIG } from '../config';

import SPClusterResourceDetailsGrid from './SPClusterResourceDetailsGrid';

export const SPClusterWorkloadResourceDetailsContainer = () => {
  const { values, initialValues } = useFormikContext();

  const spClusterWorkloadData = useSPClusterWorkloadContext();
  const spClusterWorkloadDetails = {
    name: spClusterWorkloadData.name,
    ...spClusterWorkloadData.cluster_resource_details,
  };

  const shouldFormBeDisabled = isAnythingEditedBesidesGivenFormBasedOnGivenConfig(
    initialValues,
    values,
    CLUSTER_WORKLOAD_DETAILS_CONFIG
  );
  return (
    <PaddedAndRaisedSegment disabled={shouldFormBeDisabled}>
      <SPClusterResourceDetailsGrid
        clusterWorkloadDetails={spClusterWorkloadDetails}
        disabled={shouldFormBeDisabled}
      />
    </PaddedAndRaisedSegment>
  );
};
